import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "../locales/en/common.json";
import spCommon from "../locales/sp/common.json";

export const defaultNS = "common";
export const resources = {
  en: {
    common: enCommon,
  },
  sp: {
    common: spCommon,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "sp"],
    ns: [defaultNS],
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    react: {
      useSuspense: true,
    },
  })
  .catch((error) => {
    console.error("Failed to initialize i18n", error);
  });

export default i18n;
